import React from 'react';
import { StarIcon as StarIconSolid } from '@heroicons/react/solid';
import { StarIcon as StarIconOutline } from '@heroicons/react/outline';

type Props = {
  onChange: (stars: number) => void;
  rating: number;
  disabled?: boolean;
};

export default function Rating(props: Props) {
  const { onChange, rating, disabled } = props;

  const update = (rating: number) => {
    if (!disabled) {
      onChange(rating);
    }
  };
  return (
    <div>
      <ul className="flex space-x-1 justify-center">
        {new Array(5).fill(0).map((_, index) => {
          return (
            <li key={index}>
              {index < rating ? (
                <button
                  title={`${index} stars`}
                  onClick={() => update(index + 1)}
                >
                  <StarIconSolid className="w-6 text-yellow-300 hover:cursor-pointer" />
                </button>
              ) : (
                <button
                  title={`${index} stars`}
                  onClick={() => update(index + 1)}
                >
                  <StarIconOutline className="w-6 text-grey-medium hover:text-yellow-300 hover:cursor-pointer" />
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
